/**
 * Web Engine Connector — cloud / local / none modes.
 *
 * Thin wrapper around the shared createEngineConnectorStore factory.
 */

import {
    type BaseEngineMode,
    createEngineConnectorStore,
} from "@magic-md/editor-core";

export type EngineSource = BaseEngineMode;

export const useEngineConnectorStore = createEngineConnectorStore({
    storageKey: "magic-md-web-engine-settings",
    stubPrefix: "web",
    urlEndpointParam: "gateway",
    defaultLocalEndpoint: "http://127.0.0.1:3721",
    resetModeOnDisconnect: true,
});
